import _regeneratorRuntime from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import renderHeadless from './render-headless';
import { RenderType } from 'vega-scenegraph';
/**
 * Produce a rendered SVG string of the visualization.
 * This method is asynchronous, returning a Promise instance.
 * @return {Promise} - A promise that resolves to an SVG string.
 */

export default function (_x) {
  return _ref.apply(this, arguments);
}

function _ref() {
  _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(scaleFactor) {
    var r;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return renderHeadless(this, RenderType.SVG, scaleFactor);

          case 2:
            r = _context.sent;
            return _context.abrupt("return", r.svg());

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _ref.apply(this, arguments);
}